import createModel from 'utils/model'
import {allChannels, businessChannels, addChannel, editChannel} from 'services/channels'

export default createModel({
    namespace: 'channels',
    state: {},

    subscriptions: {},

    effects: {
        *allChannels({payload}, {call}) {
            return yield call(allChannels, payload)
        },

        // 商家渠道：不包含默认，活动裂变
        *businessChannels({payload}, {call}) {
            return yield call(businessChannels, payload)
        },

        // 创建渠道
        *addChannel({payload, callback}, {call}) {
            const res = yield call(addChannel, payload)

            if (res && res.meta.code === 200) {
                callback && callback(res)
            }
            return res
        },

        // 编辑渠道
        *editChannel({payload, callback}, {call}) {
            const res = yield call(editChannel, payload)

            if (res && res.meta.code === 200) {
                callback && callback(res)
            }
            return res
        },
    },

    reducers: {},
})
